<!-- 保单信息 -->
<template>
  <div>
    <a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
      <div class="title_">
        <div class="cutleft_">保单信息</div>
        <div class="cutoff_"></div>
      </div>
      <a-form-item :label-col="{ span: 3 }" label="起止日期" :wrapper-col="{ span: 21 }">
        <a-row>
          <a-date-picker :disabled-date="disabledDate" :disabled="disabledAll" :showTime="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }" placeholder="开始日期" v-decorator="['baodanData.startdata', { rules: [{ required: true, message: '请选择起始日期！' }] }]" @change="effectiveDateChange" />
          <a-date-picker :showTime="{ defaultValue: moment('23:59:59', 'HH:mm:ss') }" style="margin-left: 20px" disabled placeholder="结束日期" v-model="applicantInfoExpireDate" />
        </a-row>
      </a-form-item>
      <div class="title_">
        <div class="cutleft_">投保企业信息</div>
        <div class="cutoff_"></div>
      </div>
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="投保企业名称">
            <a-input :disabled="disabledAll" v-model="applicantInfo.name" v-decorator="['applicantInfo.name', { rules: [{ required: true, message: '请输入投保企业名称' }] }]" placeholder="请输入投保企业名称" @blur="queryCompanyCodeByName()"></a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="投保企业证件类型">
            <a-select
              :disabled="disabledAll"
              @change="value => handleChange(value, 'idType')"
              v-decorator="[
                'applicantInfo.idType',
                {
                  rules: [{ required: true, message: '请选择投保企业证件类型' }],
                },
              ]"
              placeholder="请选择投保企业证件类型"
            >
              <a-select-option v-for="item in companyIdTypeOptions" :key="item.value" :value="item.value">{{ item.name }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="12">
					<div class="idNumber-form-item">
						<a-form-item :label-col="{ span: 6 }" label="投保企业证件号码">
							<a-input
								:disabled="true"
								v-model="applicantInfo.idNumber"
								v-decorator="[
									'applicantInfo.idNumber',
									{
										rules: [
											{ required: true, message: '请输入投保企业证件号码' },
										],
									},
								]"
								placeholder="请输入投保企业证件号码"
							></a-input>
						</a-form-item>
						<!-- 客服二维码组件 -->
						<customerService></customerService>
					</div>
        </a-col>
      </a-row>
      <a-row :span="24">
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="企业地址">
            <a-cascader
              :disabled="disabledAll"
              placeholder="请选择"
              style="width: 293px"
              @change="(value, label) => handleChange(value, 'pacCode', label)"
              v-decorator="[
                'applicantInfo.pacCode',
                {
                  rules: [{ required: true, message: '请输入省市' }],
                },
              ]"
              :options="addressOptions"
              :fieldNames="{
                label: 'text',
                value: 'value',
                children: 'children',
              }"
            />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="详细地址" style="margin-left: 10px">
            <a-input
              :disabled="disabledAll"
              v-model="applicantInfo.address"
              v-decorator="[
                'applicantInfo.address',
                {
                  rules: [{ required: true, message: '请输入联系地址' }],
                },
              ]"
              placeholder="请输入联系地址"
              style="width: 294px"
            ></a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="联系人姓名">
            <a-input
              :disabled="disabledAll"
              v-model="applicantInfo.contactsname"
              v-decorator="[
                'applicantInfo.contactsname',
                {
                  rules: [{ required: true, message: '请输入联系人姓名' }],
                },
              ]"
              placeholder="请输入联系人姓名"
            ></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="联系人电话">
            <a-input
              :disabled="disabledAll"
              v-model="applicantInfo.contactsphone"
              v-decorator="[
                'applicantInfo.contactsphone',
                {
                  rules: [{ required: true, message: '请输入联系人电话' },
                    { pattern: $regTest.checkPhone, message: '联系人电话不正确' }],
                },
              ]"
              placeholder="请输入联系人电话"
            ></a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="联系人邮箱">
            <a-input
              :disabled="disabledAll"
              v-model="applicantInfo.email"
              v-decorator="[
                'applicantInfo.email',
                {
                  rules: [{ required: true, message: '请输入联系人邮箱' },
                    { pattern: $regTest.checkEmail, message: '联系人邮箱不正确' }],
                },
              ]"
              placeholder="请输入联系人邮箱"
            ></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="支付方式">
            <a-select
              :disabled="disabledAll"
              @change="value => handleChange(value, 'payMethod')"
              placeholder="请选择支付方式"
              v-decorator="[
                'applicantInfo.payMethod',
                {
                  rules: [{ required: true, message: '请选择支付方式' }],
                },
              ]"
            >
              <a-select-option v-for="item in payTypeList" :key="item.value" :value="item.value">{{ item.text }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
      <a-divider />
      <a-row>
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="被保险人全称">
            <a-input v-model="applicantInfo.insureName" :disabled="disabledAll" v-decorator="['applicantInfo.insureName', { rules: [{ required: true, message: '请选择支付方式' }] }]" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }">
            <a-checkbox :disabled="disabledAll" @change="onChangeConSfid" :checked="ttbren"> 同投保人 </a-checkbox>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="被保险人证件类型">
            <a-select
              :disabled="disabledAll"
              @change="value => handleChange(value, 'idType')"
              v-model="applicantInfo.insureIdType"
              v-decorator="[
                'applicantInfo.insureIdType',
                {
                  rules: [{ required: true, message: '请选择证件类型' }],
                },
              ]"
              placeholder="请选择证件类型"
            >
              <a-select-option v-for="item in companyIdTypeOptions" :key="item.value" :value="item.value">{{ item.name }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="被保人证件号码">
            <a-input
              :disabled="disabledAll"
              v-model="applicantInfo.insureIdNumber"
              v-decorator="[
                'applicantInfo.insureIdNumber',
                {
                  rules: [
                    { required: true, message: '请输入被保人证件号码' },
                  ],
                },
              ]"
              placeholder="请输入被保人证件号码"
            ></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="被保人地址">
            <a-cascader
              :disabled="disabledAll"
              placeholder="请选择"
              style="width: 293px"
              @change="(value, label) => handleChange(value, 'insurePacCode', label)"
              v-decorator="[
                'applicantInfo.insurePacCode',
                {
                  rules: [{ required: true, message: '请输入省市' }],
                },
              ]"
              :options="addressOptions"
              :fieldNames="{
                label: 'text',
                value: 'value',
                children: 'children',
              }"
            />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="被保人详细地址">
            <a-input
              :disabled="disabledAll"
              v-model="applicantInfo.insureAddress"
              v-decorator="[
                'applicantInfo.insureAddress',
                {
                  rules: [{ required: true, message: '请输入被保人详细地址' }],
                },
              ]"
              placeholder="请输入被保人地址"
            ></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="被保人电话">
            <a-input
              :disabled="disabledAll"
              v-model="applicantInfo.insureMobile"
              v-decorator="[
                'applicantInfo.insureMobile',
                {
                  rules: [{ required: true, message: '请输入被保人电话' },
                    { pattern: $regTest.checkPhone, message: '被保人电话不正确' }],
                },
              ]"
              placeholder="请输入被保人电话"
            ></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="被保人邮箱">
            <a-input
              :disabled="disabledAll"
              v-model="applicantInfo.insureEmail"
              v-decorator="[
                'applicantInfo.insureEmail',
                {
                  rules: [{ required: true, message: '请输入被保人邮箱' },
                    { pattern: $regTest.checkEmail, message: '被保人邮箱不正确' }],
                },
              ]"
              placeholder="请输入被保人邮箱"
            ></a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <!-- 发票信息 -->
      <div class="title_">
        <div class="cutleft_">开票信息</div>
        <div class="cutoff_"></div>
      </div>
      <a-row>
        <a-row>环保节约，提倡电子发票，如需纸质版本，请自行打印，系统将通过邮件及手机短信发送电子发票，请注意查收。</a-row>
        <a-col :span="12">
          <a-form-item :label-col="{ span: 4 }" label="发票类型">
            <a-select disabled placeholder="请选择" @change="invoiceprinttypeChange" v-decorator="['applicantInfo.invoiceprinttype', { rules: [{ required: true, message: '请选择' }] }]">
              <a-select-option value="01">暂不开票</a-select-option>
              <a-select-option value="03">电子发票</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="12" v-if="applicantInfo.invoiceprinttype == '03'">
          <a-form-item :label-col="{ span: 6 }" label="纳税人识别号">
            <a-input v-model="applicantInfo.taxpayercertificateno" v-decorator="['applicantInfo.taxpayercertificateno', { rules: [{ required: true, message: '请输入纳税人识别号' }] }]" placeholder="请输入纳税人识别号"></a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <div class="title_">
          <div class="cutleft_">总保费</div>
          <div class="cutoff_"></div>
        </div>
        <a-form-item label="保费" :label-col="{ span: 1 }">
          <a-col :span="6">
            <a-input :value="totalPremium" disabled style="width: 130px" addonAfter="元" />
          </a-col>
        </a-form-item>
      </a-row>

      <a-row :gutter="24" class="btn_list" v-show="disabledAll">
        <div class="title_">
          <div class="cutoff_"></div>
        </div>
        <a-checkbox :disabled="!agreementAllRead" @change="onChangeyueduBtn" style="margin-bottom: 20px">
          投保人已充分阅读、理解并同意
          <fileView></fileView>
        </a-checkbox>
      </a-row>
      <a-row class="order">
        <a-col :span="24">
          <a-form-item :wrapper-col="{ span: 12, offset: 10 }">
            <a-button class="btn_color" type="primary" :loading="submitLoad1" v-show="!disabledAll" @click="handleSubmit">保存订单</a-button>
            <a-button style="margin-left: 24px" class="btn_color" type="primary" v-show="disabledAll" @click="fastInsure">
              立即投保
            </a-button>
            <a-button style="margin-left: 24px" class="btn_color" type="primary" v-show="disabledAll" @click="gonOne">编辑</a-button>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
    <!-- 支付的弹窗 -->
    <a-modal class="myModal_" width="500px" title="支付确认" forceRender v-model="showPaySure" @ok="paySure" okText="确定" cancelText="关闭">
      <p style="text-align: center; font-size: 18px; margin-bottom: 0; padding: 20px; line-height: 30px">
        您投保的{{ productName() }}需支付保费
        <span style="color: #fe8f2d; font-weight: bold">
          {{ totalPremium }} </span
        >&nbsp;元
      </p>
    </a-modal>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import moment from 'moment';
let DATA = require('../data').default;
import { policyMixin } from '@/mixins/policyMixin.js';
import { idNumberMixins } from '@/mixins/idNumberMixins.js';
export default {
  //import引入的组件需要注入到对象中才能使用
  mixins: [policyMixin, idNumberMixins],
  components: {},
  data() {
    //这里存放数据
    return {
      disabledAll: false,
      yueduBtn: false, //阅读中
      submitLoad1: false, //保存中
      submitLoad2: false, //提交中
      showPaySure: false, //支付
      postPolicyData: {}, //要提交的数据
      policyId: '', //支付回来的id
      /**需要的数据开始 */
      ttbren: false, //同被保人
      applicantInfo: {
        name: '', //投保企业名称
        idType: '', //证件类型
        idNumber: '', //证件号码
        pacCode: '', //省市区
        address: '', //详细地址
        enttypecode: '', //企业性质
        expirationDate: '', //存续时间
        contactsname: '', //联系人名称
        contactsphone: '', //联系人电话
        email: '', // 邮箱
        // beneficiary: "", // 附加被保险人
        remark: '', //备注
        invoiceprinttype: '01', //发票类型
        taxpayercertificateno: '', //纳税人识别号
        payMethod: '', //支付方式
        totalPremium: 0, //总保费
        juvenilesAvgpremuim: 0, //单个保费
        expireDate: '',
        effectiveDate: '', //投保期限

        insureName: '', //被保人名称
        insureIdType: '', //被保人证件类型
        insureIdNumber: '', //被保人证件号码
        insureAddress: '', //被保人地址
        insureMobile: '', //被保人电话
        insureEmail: '', //被保人邮箱
        insurePacCode: '', //被保人省市
        insureWorkUnit: '', //企业类型
      },
      address: '',
      //表格的数据
      data: [],
      //企业类型
      industryOptions: DATA.industryType,
      //投保人证件类型
      companyIdTypeOptions: DATA.companyIdTypeOptions,
      loading: false,
      form: this.$form.createForm(this, { name: 'advanced_search' }),
      modalVisible: false, //修改保费的弹窗
      ContentViewEduit: {}, //修改的保费
      creator: '1',
      productCode: '',
      userParams: '',
      /**需要的数据结束 */
      guapre: '1',
      mon: '12',
      baodanData: {
        startdata: '',
      },
      orderContent: {},
      totalPremium: 0, //总保费
    };
  },
  //监听属性 类似于data概念
  computed: {
    addressOptions() {
      let twoArrCode = '';
      let dataArr = window.addrescode;
      dataArr.forEach(e => {
        if (twoArrCode.indexOf(e.text) > -1) {
          e['disabled'] = true;
        }
      });
      return dataArr;
    },
    applicantInfoExpireDate() {
      let mon = this.mon;
      let date = this.applicantInfo.effectiveDate;
      let t2
      if (date && mon) {
       t2 = moment(date).add(mon, 'months').subtract(1, 's');
      }
      return t2;
    },
  },
  //监控data中的数据变化
  watch: {
    'applicantInfo.pacCode'(val) {
      sessionStorage.removeItem('pacCode');
      sessionStorage.setItem('pacCode', val[1].value || null);
    },
  },
  //方法集合
  methods: {
    moment,
    productName() {
      return sessionStorage.getItem('productName')
    },
    totalPremiumChange(money) {
      this.totalPremium = money;
    },
    //同被保人
    onChangeConSfid(e) {
      this.ttbren = e.target.checked;
      if (this.ttbren) {
        this.applicantInfo.insurePacCode = this.$lodash.cloneDeep(this.applicantInfo.pacCode);
        this.form.setFieldsValue({
          applicantInfo: {
            insureName: this.applicantInfo.name,
            insureIdType: this.applicantInfo.idType,
            insureIdNumber: this.applicantInfo.idNumber,
            insureAddress: this.applicantInfo.address,
            insureMobile: this.applicantInfo.contactsphone,
            insureEmail: this.applicantInfo.email,
            insurePacCode: [this.applicantInfo.pacCode[0].value, this.applicantInfo.pacCode[1].value],
          },
        });
      }
    },
    //理解并阅读
    onChangeyueduBtn(e) {
      this.yueduBtn = e.target.checked;
    },
    gonOne() {
      this.disabledAll = false;
      this.$bus.$emit('disabledBus', false);
      let planCode = this.$parent.$refs.riskInfo.plan;
      this.$router.push({
        name: 'mrmfgz',
        query: {
          u: this.$route.query.u,
          p: this.$route.query.p,
          sign: this.$route.query.sign,
          planCode: planCode,
        },
      });
    },
    filterPcode(arr) {
      let str;
      if (arr && arr.length) {
        if (isNaN(parseInt(arr[1]))) {
          str = 'text';
        } else {
          str = 'value';
        }
        if (!str) return;
        try {
          var addressOptions = this.$lodash.cloneDeep(this.addressOptions);
          var oneArr = addressOptions.filter(item => arr[0] == item[str]) || [];
          var twoArr = oneArr[0].children.filter(item => arr[1] == item[str]) || [];
          sessionStorage.setItem('pacCode', twoArr[0].value);
        } catch (error) {
          throw new Error(error);
        }
        return {
          code: [oneArr[0] ? oneArr[0].value : '', twoArr[0] ? twoArr[0].value : ''],
          arrCode: [oneArr[0], twoArr[0]],
        };
      }
    },
    queryOrderDetails() {
      // 查询保单信息
      let parms = {
        policyId: this.$route.query.policyId,
      };
      this.$api.queryOrderDetails(parms).then(res => {
        if (res.data.returnCode == 0) {
          if (res.data.content) {
            // 
            this.orderContent = res.data.content;
            this.$store.commit('setOrderContent', this.orderContent);
            if (res.data.content.salPolicy) {
              let salPolicy = res.data.content.salPolicy;
              this.applicantInfo.payMethod = salPolicy.payMethod;
              this.policyId = salPolicy.id.toString();
              let index = DATA.plansValues.findIndex(item => item.value == salPolicy.planCode);
              this.$parent.$refs.riskInfo.plan = salPolicy.planCode;
              if (index >= 10) {
                //C类产品
                this.$parent.$refs.riskInfo.checked = true;
              } else {
                this.$parent.$refs.riskInfo.checked = false;
              }
              this.$parent.$refs.riskInfo.planChange();
              this.applicantInfo.juvenilesAvgpremuim = salPolicy.juvenilesAvgpremuim;
              this.creator = salPolicy.creator;
              this.productCode = salPolicy.productCode;
              this.$store.commit('setproductCode', this.productCode);
              let effectiveDate;
              if (this.$route.query.xb) {
                //续保情况下时间处理
                effectiveDate = moment(salPolicy.expireDate).add(1, 'days');
              } else {
                effectiveDate = moment(salPolicy.effectiveDate);
              }
              this.applicantInfo.effectiveDate = moment(effectiveDate).format('YYYY-MM-DD HH:mm:ss');
              this.baodanData.startdata = this.applicantInfo.effectiveDate;
              this.form.setFieldsValue({
                applicantInfo: {
                  ...salPolicy,
                  effectiveDate: moment(effectiveDate).format('YYYY-MM-DD'),
                },
                baodanData: {
                  startdata: moment(effectiveDate).format('YYYY-MM-DD'),
                },
              });
            }
            this.applicantInfo.industryname = res.data.content.salPolicyHolderExt.industryname;
            let salPolicyHolder = res.data.content.salPolicyHolder || {};
            if (res.data.content.salInsuredList) {
              let insureList = res.data.content.salInsuredList[0] || {};
              salPolicyHolder.insureName = insureList.name;
              salPolicyHolder.insureIdType = insureList.idType;
              salPolicyHolder.insureIdNumber = insureList.idNumber;
              salPolicyHolder.insureAddress = insureList.address;
              salPolicyHolder.insureMobile = insureList.mobile;
              salPolicyHolder.insureEmail = insureList.email;
              salPolicyHolder.insureWorkUnit = insureList.workUnit;
              //被保人省市
              let areaArr = insureList.epolicyPath.split('-');
              let inureAreaObj = {
                province: areaArr[2],
                city: areaArr[3],
              };
              this.applicantInfo.insurePacCode = this.filterPcode([inureAreaObj.province, inureAreaObj.city] || []).arrCode;
              this.form.setFieldsValue({
                applicantInfo: {
                  insurePacCode: this.filterPcode([inureAreaObj.province, inureAreaObj.city] || []).code,
                },
              });
            }
            if (res.data.content.salPolicyHolder) {
              this.applicantInfo.name = res.data.content.salPolicyHolder.name;
              this.applicantInfo.idType = res.data.content.salPolicyHolder.idType;
              this.applicantInfo.idNumber = res.data.content.salPolicyHolder.idNumber;
              this.applicantInfo.address = res.data.content.salPolicyHolder.address;
              this.applicantInfo.contactsphone = res.data.content.salPolicyHolder.contactsphone;
              this.applicantInfo.email = res.data.content.salPolicyHolder.email;
              this.applicantInfo.pacCode = this.filterPcode([salPolicyHolder.province, salPolicyHolder.city] || []).arrCode;
              this.address = salPolicyHolder.address;
              sessionStorage.setItem('pacCode', salPolicyHolder.city);
              this.form.setFieldsValue({
                applicantInfo: {
                  ...salPolicyHolder,
                  pacCode: this.filterPcode([salPolicyHolder.province, salPolicyHolder.city] || []).code,
                },
              });
            }
          }
        }
      });
    },
    invoiceprinttypeChange(value) {
      //发票类型更改
      this.applicantInfo.invoiceprinttype = value;
    },
    //处理时间的
    effectiveDateChange(date1, date) {
      this.applicantInfo.effectiveDate = date;
    },
    //开始时间
    disabledDate(current) {
      return current && current < moment().endOf('day');
    },
    //最后的提交
    handleSubmit() {
      this.form.validateFields((err, values) => {
        if (!err) {
          let base = this.applicantInfo;
          let data = {
            salInsuredList: [
              {
                type: 'C',
                name: values.applicantInfo.insureName, //name  投保人名称
                idType: values.applicantInfo.insureIdType, //证件类型
                idNumber: values.applicantInfo.insureIdNumber, //certNo   证件号码
                address: values.applicantInfo.insureAddress, //详细地址
                mobile: values.applicantInfo.insureMobile, //联系人电话
                email: values.applicantInfo.insureEmail, //联系人邮箱
                workUnit: values.applicantInfo.insureWorkUnit, //企业类型
                relationship: '1',
                epolicyPath: `${base.insurePacCode[0].value}-${base.insurePacCode[1].value}-${base.insurePacCode[0].text}-${base.insurePacCode[1].text}`,
              },
            ],
            salPolicy: {
              //保单信息
              planCode: this.$parent.$refs.riskInfo.plan, //产品计划 （固定值ConstructAccident）
              productCode: this.productCode, //productGroupCode  产品组合代码 （固定值ConstructAccident）
              creator: this.creator,
              id: this.policyId,
              // issueDate: moment().format("YYYY-MM-DD HH:mm:ss"), //applyTime  投保时间（当前时间）
              effectiveDate: moment(values.baodanData.startdata).format('YYYY-MM-DD'), //startTime  保单生效时间
              expireDate: moment(this.applicantInfoExpireDate).format('YYYY-MM-DD'), //endTime   保单终止时间
              payMethod: values.applicantInfo.payMethod, //支付方式”
              bracket: '12', //页面选择的保障期间（几个月就传几，整数）
              totalPremium: this.totalPremium, //totalPremium  总保费
              coverageamount: '', //totalSumInsured  总保额
              remark: values.applicantInfo.remark, //备注
            },
            salPolicyHolder: {
              //投保人信息
              addfifty: '2', //测算类型
              type: 'C', //固定值
              name: values.applicantInfo.name, //name  投保人名称
              idType: values.applicantInfo.idType, //证件类型
              idNumber: values.applicantInfo.idNumber, //certNo   证件号码
              address: values.applicantInfo.address, //详细地址
              enttypecode: values.applicantInfo.enttypecode, //企业性质
              expirationDate: values.applicantInfo.expirationDate, //存续时间
              contactsname: values.applicantInfo.contactsname, //联系人姓名
              contactsphone: values.applicantInfo.contactsphone, //联系人电话
              telephone: values.applicantInfo.contactsphone, //联系人电话
              email: values.applicantInfo.email, //联系人邮箱
              pacCode: values.applicantInfo.pacCode, //地区code
              province: base.pacCode[0].text, //省
              city: base.pacCode[1].text, //市
              district: '', //区
              addresscode: `${base.pacCode[0].value}-${base.pacCode[1].value}`,
              invoiceprinttype: values.applicantInfo.invoiceprinttype, //"发票类型，电子普通发票：01、暂不开票：03",
              taxpayercertificatetype: values.applicantInfo.invoiceprinttype == '01' ? values.applicantInfo.taxpayercertificateno : '01',
            },
            salPolicyHolderExt: {
              industryname: this.applicantInfo.industryname,
            },
          };
          
          this.postPolicyData = data;
          // return
          if (this.$route.query.policyId) {
            this.postPolicyData.salPolicy.policyId = this.$route.query.policyId;
          }
          this.submitLoad1 = true;
          this.axiosPolicy(); // 保存订单是 直接保存
        } else {
          this.$message.error('请填写完整提交的数据');
        }
      });
    },
    //立即投保
    fastInsure() {
      if (!this.yueduBtn) {
        this.$message.warning('请确认已充分阅读、理解并同意《保险条款》《投保须知》《责任免除》', 2);
        return;
      }
      this.$store.commit('setLoading', { show: true, text: '核保中...' });
      let data = {
        policyId: this.$route.query.policyId,
      };
      this.$api
        .groupUnderwriting(data)
        .then(res => {
          if (res.data.returnCode == '0000') {
            this.submitLoad2 = true;
            this.showPaySure = true;
          }
        })
        .finally(() => {
          this.$store.commit('setLoading', { show: false });
        });
    },
    axiosPolicy() {
      //提交保单
      this.$store.commit('setLoading', { show: true, text: '保存中...' });
      this.$api
        .addPAPolicy(this.postPolicyData)
        .then(res => {
          if (res.data.returnCode == '00') {
            this.showPaySure = false;
            this.policyId = res.data.content;
            this.$message.success('保存成功！');
            this.$router.push({
              name: 'mrmfgz',
              query: {
                u: this.$route.query.u,
                p: this.$route.query.p,
                sign: this.$route.query.sign,
                policyId: this.policyId,
                planCode: this.postPolicyData.salPolicy.planCode,
                continuation: '1'
              },
            });
            this.disabledAll = true;
            this.$bus.$emit('disabledBus', true);
          }
        })
        .finally(() => {
          this.$store.commit('setLoading', { show: false });
          this.submitLoad1 = false;
        });
    },
    paySure() {
      //支付确认
      this.showPaySure = false;
      this.submitLoad1 = false;
      this.submitLoad2 = false;
      this.policyId = this.$route.query.policyId;
      this.$payModal({
        show: true,
        type: 'mrmfgz', //产品类型
        policyId: this.policyId, //产品id
        creator: this.creator, //用户id
        payMethod: this.applicantInfo.payMethod, //支付方式
        productCode: this.$route.query.p, //产品code
        totalPremium: this.totalPremium, //支付总金额
        name: this.applicantInfo.name,
      });
    },
    handleChange(value, type, label) {
      if (type == 'pacCode') {
        this.applicantInfo[type] = label;
        this.address = label.length > 1 ? label[0].text + label[1].text : '';
        sessionStorage.setItem('pacCode', value[1]);
      } else if (type == 'insurePacCode') {
        this.applicantInfo[type] = label;
        sessionStorage.setItem('insurePacCode', value[1]);
      } else {
        this.applicantInfo[type] = value;
      }
      if(type == 'idType') {
        this.queryCompanyCodeByName()
      }
    },
    queryCompanyCodeByName() {
      if(!this.applicantInfo.idType) {
        return
      }
      this.queryCompanyIdNumber(this.applicantInfo.name, 1);
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  mounted() {
    this.form.setFieldsValue({
      applicantInfo: {
        invoiceprinttype: '01',
      },
    });
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.avatar-uploader >>> .ant-upload {
  width: 128px;
  height: 128px;
}

.avatar-uploader >>> .ant-upload img {
  width: 100%;
  height: 100%;
}

.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}

.btn_color {
  margin: 0 20px;
}
</style>